import React, { useContext, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { getOverlapStaff, getOvertimeStaff, saveChangePosition } from '../../../../../../services/eventsService';
import { messages } from '../../../../../../utils/language-en.json';
import { EventFetchContext } from "../../../Event";

function EventStaffAssignedListActions(props) {
  const eventFetchContext = useContext(EventFetchContext);
  const [changePosition, setChangePosition] = useState(false);
  const [positionSelected, setPositionSelected] = useState(null);

  const item = props.item;
  const event = props.event;
  const positions = props.positions;
  const staffPositions = (item.staff_positions.length > 0) ? item.staff_positions.split(',') : [];

  const positionsOptions = positions.map(position => {
    const currentPosition = item.position_event_id.toString() === position.position_event_id.toString();
    const validPosition = staffPositions.includes(position.position_id.toString());

    return {
      value: position.position_event_id,
      label: position.position_name,
      disabled: !validPosition || currentPosition
    }
  });

  const travelStyle = item.department_id && item.department_id !== event.department_id ? 'travel-staff' : '';
  const overtimeStyle = item.type === 'Staff' && (item.overtime || item.overlap) ? ' overtime-staff' : '';

  const [showOvertimeModal, setShowOvertimeModal] = useState(false);
  const [showOverlapModal, setShowOverlapModal] = useState(false);
  const [overtimeData, setOvertimeData] = useState([]);
  const [overlapData, setOverlapData] = useState([]);

  const getOvertimeData = async (item) => {
    const { data } = await getOvertimeStaff(item.staff_id, item.start_date, item.end_date);
    setOvertimeData(data.events);
    setShowOvertimeModal(true);
  }

  const getOverlapData = async (item) => {
    const { data } = await getOverlapStaff(item.staff_id, item.staff_event_id, item.start_date, item.end_date);
    setOverlapData(data.events);
    setShowOverlapModal(true);
  }

  // ** HANDLE
  // *********************************************************

  const handleSaveChangePosition = async () => {
    const buildDataToSave = {
      staff_event_id: item.staff_event_id,
      start_date: item.start_date,
      end_date: item.end_date,
      position_event_id: positionSelected.value,
      event_id: event.id,
      event_name: event.name,
      staff_name: item.staff_name,
      staff_id: item.staff_id,
      department_id: event.department_id,
    }

    try {
      const { data } = await saveChangePosition(buildDataToSave);
      const success = data.success;
      if (!success) {
        const errorMessage = data.message;
        toast.error(errorMessage);
        return
      }

      setTimeout(() => {
        toast.success(messages.success.staffPositionChanged, { autoClose: 1000 });
        setPositionSelected(null);
        setChangePosition(false);

        eventFetchContext.dispatchFetchData({ TYPE: 'EVENT_STAFF_STATS', VALUE: true });
        eventFetchContext.dispatchFetchData({ TYPE: 'EVENT_STAFF_POSITIONS', VALUE: true });
        eventFetchContext.dispatchFetchData({ TYPE: 'EVENT_CHECKIN', VALUE: true });
        eventFetchContext.dispatchFetchData({ TYPE: 'EVENT_RECONCILIATION', VALUE: true });
        eventFetchContext.dispatchFetchData({ TYPE: 'EVENT_SUMMARY', VALUE: true });
        eventFetchContext.dispatchFetchData({ TYPE: 'EVENT_STAFF_ASSIGNED_FETCH', VALUE: true });
      }, 200);
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <React.Fragment>
      <div className={"staff-members-badges d-flex align-items-center " + travelStyle + overtimeStyle }>
        { item.type === 'Staff' && item.overtime &&
          <>
            <button className="btn btn-overtime" type="button" title="Overtime"
                    onClick={() => getOvertimeData(item)}>
              <span className="badge-button badge-overtime">
                <i className="fas fa-clock"></i>
              </span>
            </button>

            <Modal show={showOvertimeModal} onHide={() => setShowOvertimeModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>
                  <i className="fas fa-clock"></i>&nbsp;Overtime - {item.staff_name}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>{parseFloat(item.week_hours).toFixed(2)} scheduled hours between {item.week_start} and {item.week_end} on these events:</p>
                <table className="modal-table">
                  <thead>
                  <tr>
                    <th>Event</th>
                    <th>Date</th>
                    <th>Hours</th>
                  </tr>
                  </thead>
                  <tbody>
                  {overtimeData.map( event => (
                    <tr key={event.id + '-' + event.hours}>
                      <td><a href={"/events/" + event.id} target="_blank" rel="noopener noreferrer">{event.name}</a></td>
                      <td>{event.start_date}</td>
                      <td>{parseFloat(event.hours).toFixed(2)}</td>
                    </tr>
                  ) )}
                  </tbody>
                </table>
              </Modal.Body>
            </Modal>
          </>
        }
        { item.overlap &&
          <>
            <button className="btn btn-overlap" type="button" title="Overlap"
                    onClick={() => getOverlapData(item)}>
              <span className="badge-button badge-overlap">
                <i className="fas fa-calendar-alt"></i>
              </span>
            </button>

            <Modal show={showOverlapModal} onHide={() => setShowOverlapModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>
                  <i className="fas fa-calendar-alt"></i>&nbsp;Overlap - {item.staff_name}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>This staff member is scheduled for another shift that conflicts with this one in these events:</p>
                <table className="modal-table">
                  <thead>
                  <tr>
                    <th>Event</th>
                    <th>Position</th>
                    <th>Date</th>
                    <th>Time</th>
                  </tr>
                  </thead>
                  <tbody>
                  {overlapData.map( event => (
                    <tr key={event.id}>
                      <td><a href={"/events/" + event.id} target="_blank" rel="noopener noreferrer">{event.name}</a></td>
                      <td>{event.assignment_name}</td>
                      <td>{event.start_date}</td>
                      <td>{event.start_time} - {event.end_time}</td>
                    </tr>
                  ) )}
                  </tbody>
                </table>
              </Modal.Body>
            </Modal>
          </>
        }
        { item.staff_id !== 0 && item.type === 'Staff' && !item.exported && !item.reconciled
          ?
        <button className="btn btn-overtime" type="button" title="Change position"
                    onClick={() => setChangePosition(true)}
          >
            <span className="badge-button badge-change-position">
              <i className="fas fa-solid fa-retweet"></i>
            </span>
          </button>
        : ''
        }
        <Modal show={changePosition} onHide={() => setChangePosition(false)} className="modal-change-position">
          <Modal.Header>
            <Modal.Title>
              <i className="fas fa-solid fa-retweet"></i>&nbsp;Change Position
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row mb-3 justify-content-center">
              <div className="col-sm-9">
                <label>Change <strong>{item.staff_name}</strong> to position:</label>
                <Select
                  placeholder="Select a position"
                  className="select-style-default"
                  options={positionsOptions}
                  onChange={selected => setPositionSelected(selected)}
                  isOptionDisabled={(option) => option.disabled}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setChangePosition(false)}>Cancel</Button>
            <Button variant="success"
              disabled={!positionSelected}
              onClick={() => handleSaveChangePosition()}
            >Change Position</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default EventStaffAssignedListActions;
